import Upselling from "../agenda/Upselling";

interface Props {
  isDiscounted?: boolean;
  handleClose?: () => void;
}
const UpsellingMobile = ({
  isDiscounted = true,
  handleClose = () => {},
}: Props) => {
  return (
    <div className="   bg-opacity-40 h-full w-full z-[99999] fixed top-0 left-0  flex items-center justify-center backdrop-blur-sm">
      <Upselling handleClose={handleClose} isDiscounted={isDiscounted} />
    </div>
  );
};

export default UpsellingMobile;
